import { render, staticRenderFns } from "./StartupListFollowedPage.vue?vue&type=template&id=56da8252&"
import script from "./StartupListFollowedPage.vue?vue&type=script&lang=js&"
export * from "./StartupListFollowedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports